module.exports = __webpack_public_path__ + "customFactor_38x38.af6b1f2637e1ff3f39f46a6bb6864d5a.png";